export const TEMPLATE_HISTORY_PREVIEW_KEY = 'template-history-preview';
